// VEC-3231 — Fuente única de los permisos de carga (borrador) de presupuesto detallado.
// Evita repetir los strings y el mapeo momento->permiso en TicketPresupuestos, TicketPresupuestoDetallado
// y CorrectivosAbm. DEBE coincidir con el backend (TicketsPresupuestosService::guardarBorrador y
// Security/Permisos.php). Si se renombra/agrega un permiso, cambiar acá y en el backend.

export const PERMISOS_CARGA_BORRADOR = [
    'TICKETS_PRESUPUESTO_CARGA_REPUESTO_INICIAL',
    'TICKETS_PRESUPUESTO_CARGA_REPUESTO_ADICIONAL',
    'TICKETS_PRESUPUESTO_CARGA_MO_INICIAL',
    'TICKETS_PRESUPUESTO_CARGA_MO_ADICIONAL',
];

// Devuelve los permisos de carga (repuestos / mano de obra) según el momento (inicial vs adicional).
export function permisosCargaPorMomento(adicional) {
    return {
        repuestos: adicional ? 'TICKETS_PRESUPUESTO_CARGA_REPUESTO_ADICIONAL' : 'TICKETS_PRESUPUESTO_CARGA_REPUESTO_INICIAL',
        manoDeObra: adicional ? 'TICKETS_PRESUPUESTO_CARGA_MO_ADICIONAL' : 'TICKETS_PRESUPUESTO_CARGA_MO_INICIAL',
    };
}
